export default "__VITE_ASSET__Dh9x1H5___"